import { render, staticRenderFns } from "./LegalPage.vue?vue&type=template&id=3ef5e104"
import script from "./LegalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef5e104')) {
      api.createRecord('3ef5e104', component.options)
    } else {
      api.reload('3ef5e104', component.options)
    }
    module.hot.accept("./LegalPage.vue?vue&type=template&id=3ef5e104", function () {
      api.rerender('3ef5e104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/legal/LegalPage.vue"
export default component.exports